import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import TextBody from 'components/TextBody'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'

function HeaderButton ({ label, onClick }) {
  return (
    <Button
      onClick={onClick}
      style={{
        marginLeft: STYLES_MARGIN.SMALLEST
      }}
    >
      <TextBody>
        {label}
      </TextBody>
    </Button>
  )
}

HeaderButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

export default HeaderButton
